<template>
    <div class="tab">
        <div class="border_box" v-for="(item, index) in data" :key="index">
            <el-row>设备-{{ index + 1 }}</el-row>

            <el-form ref="form" label-width="80px">
                <el-button @click="delBlank(index)"
                    style="float:right;margin-top:-40px;position: relative;z-index: 100;" type="danger"
                    icon="el-icon-delete" circle></el-button>

                <el-form-item label>

                    <el-col :span="6" v-for="(item_col, index_col) in dataConfig" :key="index_col">
                        <div class="input_label">{{ item_col.name +  (item_col.isNotMust ? ' *':'')}}</div>

                        <el-input v-if="item_col.type === 0" v-model="item[index_col]"
                            :placeholder="item_col.parameter"></el-input>

                        <el-radio v-if="item_col.type === 1" v-model="item[index_col]"
                            v-for="(config_radio, index_radio) in item_col.parameter" :key="index_radio"
                            :label="index_radio" style="color: #fff;">
                            {{ config_radio }}
                        </el-radio>

                        <el-select v-if="item_col.type === 2" v-model="item[index_col]" placeholder="请选择">
                            <el-option v-for="(config_select, index_select) in item_col.parameter" :key="index_select"
                                :label="config_select" :value="index_select"></el-option>
                        </el-select>

                        <el-date-picker v-if="item_col.type === 3" v-model="item[index_col]"
                            value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
                            placeholder="请选择时间"></el-date-picker>

                    </el-col>
                </el-form-item>
            </el-form>
        </div>
        <div class="search_btn green" style="float:right;margin-top: 20px;" @click="addBlank"><span>+ 添加设备</span></div>
    </div>
</template>

<script>
    export default {
        name: 's-tab-pane',
        props: {
            data: {
                type: Array,
                default: []
            },
            dataConfig: {
                type: Object,
                default: []
            }
        },
        data() {
            return {
                dataBackups: []
            };
        },
        mounted() {
            this.dataBackups = JSON.parse(JSON.stringify(this.data[0]));
        },
        methods: {
            addBlank() {
                this.data.push(JSON.parse(JSON.stringify(this.dataBackups)));
            },
            delBlank(i) {
                this.data.splice(i, 1);
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import '~@/styles/mixin.scss';

    .tab {
        .border_box {
            padding: 5px;
            margin-top: 30px;
            border: 1px dashed #1d4495;
        }

        .input_label {
            min-width: 80px;
            height: 30px;
            line-height: 30px;
            padding: 0 5px;
            display: inline-block;
            text-align: center;
            background-color: rgba(155, 249, 252, 0.1);
        }

        .search_btn {
            width: 100px;
            height: 32px;
            margin: 0 3px;
            background: url(../../assets/img/btn_bg_osm.png) no-repeat;
            background-size: 100% 100%;
            color: #ffffff;
            font-size: 14px;
            cursor: pointer;
            @include flex-box(center, center);

            span {
                margin-top: -5px;
            }

            &.green {
                background: url(../../assets/img/per_bg_g.png) no-repeat;
                background-size: 100% 100%;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/s-tab-pane/index.vue